import { Alert } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const VideoPlayer = ({ selectedRecording }: { selectedRecording?: any }) => {
  const { t } = useTranslation();

  const isExpired = useMemo(() => {
    return selectedRecording?.expiresAt
      ? new Date(selectedRecording.expiresAt) < new Date()
      : false;
  }, [selectedRecording?.expiresAt]);

  if (!selectedRecording) {
    return null;
  }

  if (isExpired || !selectedRecording?.file) {
    return (
      <Alert
        className="w-100"
        type="info"
        showIcon
        message={isExpired ? t("recap.expiredVideo") : t("recap.notFound")}
      />
    );
  }

  return (
    <div className="recap-video " style={{ position: "relative" }}>
      <video
        key={selectedRecording.id}
        src={selectedRecording.file || ""}
        className="recap-video__player"
        controls
        preload="auto"
        poster={selectedRecording.thumbnail || ""}
      />
    </div>
  );
};

export default VideoPlayer;
